import { Fragment, useEffect, useState, useRef } from 'react';
import { Popover, Transition } from '@headlessui/react';
import { ListIcons } from '../common/icons';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { store } from "../../app/redux/store/store";
import { menuActive } from "../../app/redux/actions/menu";
import {
  MenuIcon,
  XIcon,
  HomeIcon,
  UserGroupIcon,
  CogIcon,
  BadgeCheckIcon,
  ChartPieIcon,
  DownloadIcon,
  ClockIcon,
  CreditCardIcon,
  CashIcon,
  PlusIcon
} from '@heroicons/react/outline';
import storage from "redux-persist/lib/storage";
import Button from "../common/Button";
import { IconRestaurante } from '../common/icons';
import WithPermission from '../../app/WithPermission';
import { customPost } from '../../utils/services';
import toast from 'react-hot-toast';
const { REACT_APP_NAME } = process.env;

const menu = [
  {
    name: 'Ventas',
    href: '/restaurante/ventas',
    icon: ListIcons,
    permiso: 'venta-create'
  },
  {
    name: 'Venta Directa',
    href: '/restaurante/venta-directa',
    icon: PlusIcon,
    permiso: 'venta-create'
  },
  {
    name: 'Ordenes',
    href: '/restaurante/ordenes',
    icon: IconRestaurante,
    permiso: 'venta-list'
  },
  {
    name: 'Ordenes del dia',
    href: '/restaurante/ordenes-del-dia',
    icon: ClockIcon,
    permiso: 'venta-list'
  },
  {
    name: 'Compras',
    href: '/restaurante/compras',
    icon: DownloadIcon,
    permiso: 'compra-list'
  },
  {
    name: 'Reportes',
    href: '/restaurante/reportes',
    icon: ChartPieIcon,
    permiso: 'report-list'
  },
  {
    name: 'Cortes',
    href: '/cortes-restaurante',
    icon: CreditCardIcon,
    permiso: 'reserva-list'
  },
  {
    name: 'Gastos',
    href: '/restaurante/gastos-restaurante?restaurante=true',
    icon: CashIcon,
    permiso: 'reserva-list'
  },
]

const menuAdmin = [
  {
    name: 'Catalogos',
    href: '/restaurante/catalogos',
    icon: ListIcons,
    permiso: 'room-list'
  },
  {
    name: 'Proveedores',
    href: '/restaurante/proveedores',
    icon: UserGroupIcon,
    permiso: 'compra-list'
  },
  {
    name: 'Productos',
    href: '/restaurante/productos',
    icon: BadgeCheckIcon,
    permiso: 'producto-list'
  },
  {
    name: 'Menus',
    href: '/restaurante/menus',
    icon: IconRestaurante,
    permiso: 'menu-list'
  },
]

export default function MenuRestaurante() {
  const loginState = useSelector((state) => state?.loginReducer?.data);
  const [hidden, setHidden] = useState(true);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showModalPassword, setShowModalPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loadingPassword, setLoadingPassword] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const cerrarSesion = () => {
    storage.removeItem("persist:root");
    storage.removeItem("token");
    window.location = "/";
  };

  const cambiarPassword = async () => {
    if (!password || !confirmPassword) {
      toast.error('Completa ambos campos');
      return;
    }
    if (password !== confirmPassword) {
      toast.error('Las contraseñas no coinciden');
      return;
    }
    setLoadingPassword(true);
    try {
      const result = await customPost(
        { password, confirm_password: confirmPassword },
        'cambiar-password',
        loginState?.token
      );
      if (result?.data?.success) {
        toast.success('Contraseña actualizada');
        setShowModalPassword(false);
        setPassword('');
        setConfirmPassword('');
        cerrarSesion();
      } else {
        toast.error(result?.data?.message || 'Error al cambiar la contraseña');
      }
    } catch {
      toast.error('Error al cambiar la contraseña');
    }
    setLoadingPassword(false);
  };

  return (
    <div>
      <Popover className="relative ">
        <div className="bg-primary">
          <div className="hidden md:flex-1 md:flex md:items-center md:justify-between max-w-7xl mx-auto justify-between items-center px-4 py-3">
            <a href="/" className="text-base text-white font-medium" onClick={() => {
              store.dispatch(menuActive(''));
            }}>
              Hotel { REACT_APP_NAME }
            </a>
            <div className="flex items-center md:ml-12">
              <div className="ml-3 flex flex-row items-center bg-blueSecond py-1 px-5 rounded-lg hover:bg-secondary relative" ref={dropdownRef}>
                <span className="inline-flex items-center justify-center h-6 w-6 ring-2 ring-white rounded-full bg-blueSecond">
                  <span className="text-sm font-medium leading-none text-white">
                    {loginState?.userData?.email.substring(0, 2).toUpperCase()}
                  </span>
                </span>
                <div className="flex flex-col items-start justify-center ml-2">
                  <h1 className="text-xs font-bold text-white">
                    {`${loginState?.userData?.email} `}
                  </h1>
                  <span className="text-xs font-bold text-white cursor-pointer" onClick={() => setShowDropdown(!showDropdown)}>
                    mi cuenta ▾
                  </span>
                </div>
                {showDropdown && (
                  <div className="absolute top-full right-0 mt-1 w-44 bg-white rounded-lg shadow-lg z-50 overflow-hidden">
                    <button
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      onClick={() => { setShowDropdown(false); setShowModalPassword(true); }}
                    >
                      Cambiar contraseña
                    </button>
                    <button
                      className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                      onClick={cerrarSesion}
                    >
                      Cerrar sesión
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="absolute inset-0 shadow z-30 pointer-events-none" />
        <div className="px-4 xl:px-44 lg:px-40 md:px-32 flex justify-between xl:justify-center lg:justify-center md:justify-center items-center py-4 bg-blueSecond">
          <div>
            <span></span>
          </div>
          <div className="-mr-2 -my-2 md:hidden">
            <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center
             text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:ring-2 focus:ring-primary">
              <span className="sr-only">Open menu</span>
              <MenuIcon className="h-6 w-6" />
            </Popover.Button>
          </div>
          <div className="hidden xl:flex lg:flex md:flex md:items-center md:justify-between -my-3">
            {menu.map((item) => (
              <WithPermission permiso={item.permiso} key={item.name} >
                <Link to={item.href} className="rounded-lg">
                  <div className="flex flex-col justify-center items-center hover:bg-secondary cursor-pointer py-1 px-8 rounded-lg">
                    <div className="flex flex-col">
                      <span className="inline-flex items-center justify-center h-10 w-10 rounded-md bg-primary text-white">
                        <item.icon className="h-6 w-6" />
                      </span>
                    </div>
                    <p className="text-sm font-medium text-white">{item.name}</p>
                  </div>
                </Link>
              </WithPermission>
            ))}
            <Popover>
              {() => (
                <>
                  {
                    <Popover.Button onClick={() => { setHidden(false) }}>
                      <div className="flex flex-col justify-center items-center hover:bg-secondary cursor-pointer py-1 px-5 rounded-lg">
                        <div className="flex flex-col">
                          <span className="inline-flex items-center justify-center h-10 w-10 rounded-md bg-primary text-white">
                            <CogIcon className="h-6 w-6" />
                          </span>
                        </div>
                        <p className="text-sm font-medium text-white">Administracion</p>
                      </div>
                    </Popover.Button>
                  }

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 -translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 -translate-y-1"
                  >
                    <Popover.Panel className={`${hidden ? 'hidden' : 'absolute z-50 top-full inset-x-0 transform shadow-lg'}`}>
                      <div className="grid grid-cols-1">
                        <nav className="py-2 bg-white flex flex-row justify-center">
                          {menuAdmin.map((item) => (
                            <WithPermission permiso={item.permiso} key={item.name}>
                              <Link to={item.href} className="rounded-lg" onClick={() => { setHidden(true) }}>
                                <div className="flex flex-col justify-center items-center hover:bg-gray-100 cursor-pointer py-2 px-12 rounded-lg">
                                  <div className="flex flex-col">
                                    <span className="inline-flex items-center justify-center h-10 w-10 rounded-md bg-primary text-white">
                                      <item.icon className="h-6 w-6" />
                                    </span>
                                  </div>
                                  <p className="text-base font-medium text-gray-900">{item.name}</p>
                                </div>
                              </Link>
                            </WithPermission>
                          ))}
                        </nav>
                      </div>
                    </Popover.Panel>
                  </Transition>
                </>
              )}
            </Popover>
          </div>
        </div>

        <Transition
          as={Fragment}
          enter="duration-200 ease-out"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="duration-100 ease-in"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Popover.Panel
            focus
            className="absolute z-50 top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
          >
            <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
              <div className="pt-5 pb-6 px-5 sm:pb-8">
                <div className="flex items-center justify-between">
                  <span className='font-medium text-primary'>{ REACT_APP_NAME }</span>
                  <div className="-mr-2">
                    <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-red-400">
                      <span className="sr-only">Close menu</span>
                      <XIcon className="h-6 w-6" />
                    </Popover.Button>
                  </div>
                </div>
                <div className="mt-6 sm:mt-8">
                  <nav>
                    <div className="grid gap-7 sm:grid-cols-2 sm:gap-y-8 sm:gap-x-4">
                      {menu.map((item) => (
                        <WithPermission permiso={item.permiso} key={item.name}>
                          <Link to={item.href} className="-m-3 flex items-center p-3 rounded-lg hover:bg-gray-50"  >
                            <div className="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-primary text-white sm:h-12 sm:w-12">
                              <item.icon className="h-6 w-6" />
                            </div>
                            <div className="ml-4 text-base font-medium text-gray-900">{item.name}</div>
                          </Link>
                        </WithPermission>
                      ))}
                    </div>
                  </nav>
                </div>
              </div>
              <div className="py-6 px-5">
                <Button
                  text="Cerrar sesion"
                  onClick={() => { cerrarSesion() }}
                />
              </div>
            </div>
          </Popover.Panel>
        </Transition>
      </Popover>

      {showModalPassword && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75" onClick={() => setShowModalPassword(false)} />
          <div className="relative bg-white rounded-lg shadow-xl p-6 w-full max-w-sm mx-4">
            <button
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
              onClick={() => setShowModalPassword(false)}
            >
              <XIcon className="h-5 w-5" />
            </button>
            <h3 className="text-lg font-medium text-gray-900 mb-4 text-center">Cambiar contraseña</h3>
            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nueva contraseña</label>
                <input
                  type="password"
                  className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Nueva contraseña"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Confirmar contraseña</label>
                <input
                  type="password"
                  className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirmar contraseña"
                />
              </div>
              <button
                className="w-full bg-primary text-white rounded-md py-2 text-sm font-medium hover:bg-secondary disabled:opacity-50"
                onClick={cambiarPassword}
                disabled={loadingPassword}
              >
                {loadingPassword ? 'Guardando...' : 'Guardar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}